//import styles
import "./scss/app.scss"

//import jQuery scripts
try {
    window.$ = window.jQuery = require('jquery')
} catch (e) {}

require('./js/jquery/burger-menu')
require('./js/jquery/header')
require('./js/jquery/scrolling')
require('./js/jquery/slick')
require('./js/jquery/slick-settings')